export default __webpack_public_path__ + "static/media/exercise.29073c77.svg";